import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

document.addEventListener("turbo:load", () => {
  flatpickr("[data-behavior='flatpickr-reports']", {
    dateFormat: 'Y-m-d',
    "locale": Russian,
    maxDate: 'today'
  })
})
